import { isEmpty } from "lodash";
import { markdown } from "../../../helpers/markdown";

interface HintProps {
  hint?: string;
  className?: string;
}

function Hint({ hint, className = "" }: HintProps) {
  return isEmpty(hint) ? null : (
    <div
      className={`help-block ${className}`}
      dangerouslySetInnerHTML={{ __html: markdown(hint) }}
    />
  );
}

export default Hint;
